import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IARDialogStyles } from "./ARDialog.types"

export const ARDialogStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IARDialogStyles>
> = () => ({
    root: {},

    qr: {
        display: "flex",
        justifyContent: "center"
    },

    footer: {
        display: "flex",
        justifyContent: "center"
    }
})
